import { Config } from "@config";
import imgDekany from "@img/avatar/dekanybalazs.jpg";
import imgNagy from "@img/avatar/nagy.jpg";
import imgSass from "@img/avatar/sass.jpg";
import imgBmLogo from "@img/logos/bankmonitor-mini.svg";
import { __ } from "bm-ui-kit";
import type { ReactNode } from "react";
import React from "react";
import { Col, Row } from "react-bootstrap";

type Experts = "nagy" | "sass" | "dekany";

interface Props {
	expertId: Experts;
	quote: string;
	title: string;

	useNewDesign?: boolean;
}

const EXPERTS: Record<Experts, { name: string; imgSrc: string }> = {
	nagy: {
		name: "Nagy Ildikó",
		imgSrc: imgNagy,
	},
	sass: {
		name: "Sass Róbert",
		imgSrc: imgSass,
	},
	dekany: {
		name: "Dékány Balázs",
		imgSrc: imgDekany,
	},
};

export class ExpertBlockquote extends React.PureComponent<Props> {
	public render(): ReactNode {
		const { expertId, quote, title, useNewDesign } = this.props;
		const { name, imgSrc } = EXPERTS[expertId] || { name: "", imgSrc: "" };

		if (!(Config.showPoweredByBankmonitor() || Config.showConsultantQuotes())) {
			return null;
		}

		if (useNewDesign) {
			return (
				<Row className="align-items-center mt-5 mb-4">
					<Col className="text-left mt-5" md={3}>
						<img
							className="img-thumbnail rounded-circle shadow mb-md-0 mb-3"
							alt={Config.showConsultantQuotes() ? name : "Bankmonitor"}
							width="116"
							height="116"
							src={Config.showConsultantQuotes() ? imgSrc : imgBmLogo}
						/>
					</Col>
					<Col md={9} className="mt-5">
						<figure className="text-left mt-3">
							<blockquote className="blockquote">
								<p className="mb-0 small">„{__(quote)}”</p>
							</blockquote>
							<figcaption className="blockquote-footer text-reset font-weight-bold">
								{Config.showConsultantQuotes() && <cite>{__(name)},</cite>} {__(title)}
							</figcaption>
						</figure>
					</Col>
				</Row>
			);
		}

		return (
			<Row className="align-items-center mt-auto">
				<Col className="text-center" md={3}>
					<img
						className="img-thumbnail rounded-circle shadow mb-md-0 mb-3"
						alt={Config.showConsultantQuotes() ? name : "Bankmonitor"}
						width="160"
						height="160"
						src={Config.showConsultantQuotes() ? imgSrc : imgBmLogo}
					/>
				</Col>
				<Col md={9}>
					<figure className="text-right mb-0">
						<blockquote className="blockquote">
							<p>„{__(quote)}”</p>
						</blockquote>
						<figcaption className="blockquote-footer text-reset">
							{Config.showConsultantQuotes() && <cite>{__(name)},</cite>} {__(title)}
						</figcaption>
					</figure>
				</Col>
			</Row>
		);
	}
}
